(function() {
    'use strict';

    angular.module('allegro').controller('AllegroOauthCreateController', AllegroOauthCreateController);

    AllegroOauthCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst'
    ];

    function AllegroOauthCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroConfigDataSrvc,
        allegroConfigMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            client_id: [],
            client_secret: [],
            base_url: [],
            base_api_url: [],
            user_agent: null,
            non_field_errors: []
        };

        self.account = {};
        self.configurationData = {
            pk: null,
            account: null,
            client_id: '',
            client_secret: '',
            base_url: '',
            base_api_url: '',
            user_agent: {}
        };

        self.getAccount = getAccount;
        self.createConfiguration = createConfiguration;
        self.cleanErrors = cleanErrors;

        active()
        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createConfiguration() {
            self.configurationData.account = self.account.pk;

            allegroConfigDataSrvc.create(self.configurationData)
                .$promise.then(function(response) {
                    notificationSrvc.notification("success", allegroConfigMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.overview', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
